import { gql } from '@apollo/client';

export const GET_SERVICES = gql`
  query GetServices {
    serviceIntegrations {
      id
      name
      category
      providerName
    }
  }
`;

export const CREATE_COMPANY_SERVICE_INTEGRATION = gql`
  mutation createCompanyServiceIntegration($companyMemberId: ID!, $serviceIntegrationId: ID!){
          createCompanyServiceIntegration(companyMemberId: $companyMemberId, serviceIntegrationId: $serviceIntegrationId){
            companyServiceIntegration {
              id,
              serviceIntegration {
                id,
                name,
                category
              }
            }
          }
        }
`;

export const UPDATE_COMPANY_SERVICE_INTEGRATION = gql`
  mutation updateCompanyServiceIntegration($id: ID!, $attributes: CompanyServiceIntegrationAttributes!){
            updateCompanyServiceIntegration(id: $id, attributes: $attributes){
              companyServiceIntegration {
                id
                status
              }
            }
          }
`;

export const DELETE_COMPANY_SERVICE_INTEGRATION = gql`
mutation deleteCompanyServiceIntegration($companyServiceIntegrationId: ID!){
            deleteCompanyServiceIntegration(companyServiceIntegrationId: $companyServiceIntegrationId) {
              companyServiceIntegration {
                id,
                serviceIntegration{
                  id,
                  name,
                  category
                }
              }
            }
          }
`;

export const GET_COMPANY_MEMBER_BY_USER_ID = gql`
  query CompanyMember($userId: ID!, $companyId: ID!) {
    companyMembers(userId: $userId, companyId: $companyId) {
      id
      company{
        id
        plan
        stripeCustomerId
      }
      companyServiceIntegrations {
        id
        status
        serviceIntegration {
          id
          name
          category
          providerName
        }
      }
    }
  }
`;
